module.exports = __webpack_public_path__ + "img/banner5.53866708.png";